<template>
  <div>
    <header class="header">Xisobotlar royhati:</header>
    <el-button class="addBtn" type="primary" v-if="userRole" @click="onAddItem"
      >Yangi qo'shish</el-button
    >
    <el-table :data="tableData" style="max-width: 800px" max-height="250">
      <el-table-column prop="id" label="" width="50" />
      <el-table-column prop="report_year" label="Xisobot yili" width="150" />
      <el-table-column
        prop="created_date"
        label="Yaratilgan sana"
        width="170"
      />
      <el-table-column prop="last_update" label="Songi taxrir" width="150" />
      <el-table-column label="Operations" width="300">
        <template #default="scope">
          <div class="flex">
            <el-button
              type="primary"
              size="small"
              @click.prevent="editReport(scope.row)"
            >
              Tahrirlash
            </el-button>
            <el-button type="primary" size="small"> Yuklab olish </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="dialogFormVisible"
      title="Yangi xisobot yaratish uchun yilni tanlang"
    >
      <el-form :model="form">
        <el-form-item label="Yilni tanglang" label-width="140px">
          <el-select v-model="selectedYear">
            <el-option
              :label="year.title"
              :value="year.title"
              v-for="year in years"
              :key="year.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Bekor qilish</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">
            Yaratish
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import store from "@/store";

const router = useRouter();

const now = new Date();
const dialogFormVisible = ref(false);
const selectedYear = ref(null);
const years = ref([
  { title: "2022", id: 1 },
  { title: "2021", id: 2 },
  { title: "2020", id: 3 },
]);
const tableData = ref([
  {
    id: 1,
    report_year: "2016",
    created_date: "2016-05-01",
    last_update: "2021-03-01",
  },
  {
    id: 2,
    report_year: "2019",
    created_date: "2016-05-01",
    last_update: "2021-03-01",
  },
  {
    id: 3,
    report_year: "2022",
    created_date: "2016-05-01",
    last_update: "2021-03-01",
  },
  {
    id: 4,
    report_year: "2023",
    created_date: "2016-05-01",
    last_update: "2021-03-01",
  },
]);

const editReport = (report) => {
  router.push({
    name: "SavingForm",
    params: { id: report.id },
    query: { year: report.report_year },
  });
};

const onAddItem = () => {
  dialogFormVisible.value = true;
};

const userRole = computed(() => {
  return store.state.role === "admin";
});
</script>

<style scoped>
.header {
  font-weight: bold;
  height: 70px;
}

.flex {
  display: flex;
}

.addBtn {
  margin-bottom: 20px;
}
</style>
